<template>
  <v-app id="inspire">
    <v-main>
      <div class="tw-w-full tw-flex">

        <v-col class="image tw-hidden lg:tw-block image tw-h-auto tw-flex tw-justify-center" cols="12" sm="12" md="7">
          <div class="tw-w-full tw-h-screen tw-flex tw-justify-center tw-items-end">
            <div class="tw-w-10/12 tw-flex flex-wrap tw-justify-center tw-mt-10 lg:tw-mt-0 tw-px-4 md:tw-px-12">
              <div v-if="show" class="tw-px-16 tw-w-full tw-mt-4 tw-text-left tw-text-white tw-flex tw-items-center">
                <a id="playstore-link" class="" href="https://play.google.com/store/apps/details?id=ke.co.apollo.client.app" target="_blank" rel="noopener"><img src="/images/google-play-badge.png" width="130" alt="play store"></a>
                <p class="tw-text-xs md:tw-text-base md:tw-text-left tw-px-2  tw-mt-3">You can also download our Motor Happiness App on the Google play store</p>
              </div>
            </div>
          </div>
        </v-col>
        <v-col class="tw-h-auto tw-px-6 md:tw-px-24 tw-flex tw-flex-wrap tw-items-center tw-justify-center" id="login" cols="12" sm="12" md="5">
          <v-card class="tw-w-full elevation-3 tw-mt-8">
            <div class="tw-w-full tw-flex tw-justify-center">
              <img src="/logo.svg" class="tw-w-24 md:tw-w-32 tw-mt-4 md:tw-mt-6" alt="logo">
            </div>
            <v-card-text class="tw-px-4 md:tw-px-10" >
              <v-form v-model="isValid" ref="form">
                <v-text-field
                    id="email"
                    class="my-5"
                    label="Email"
                    type="email"
                    name="email"
                    v-model="form.email"
                    :rules="[required('Email'), emailFormat()]"
                >
                  <v-icon slot="prepend" color="primary">mdi-email</v-icon>
                </v-text-field>
                <v-text-field
                    id="password"
                    label="Password"
                    :type="passwordField"
                    v-model="form.password"
                    :rules="[required('Password')]"
                >
                  <v-icon slot="prepend" color="primary">mdi-lock</v-icon>
                  <v-icon slot="append" color="primary" class="tw-cursor-pointer" @click="passwordField = passwordField === 'password' ? 'text' : 'password'">{{ passwordField === 'password' ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                </v-text-field>
              </v-form>
              <div class="col-md-12 d-flex justify-end tw--mt-4 tw--mb-6">
                <router-link class="no-underline c-gray-text text-15-b" :to="{name: 'ForgotPassword'}"> Forgot password </router-link>
              </div>

            </v-card-text>

            <v-card-actions class="col-sm-6 offset-sm-3">
              <v-btn block large
                     id="signIn"
                     color="primary"
                     class="my-3 "
                     @click="onSignIn"
                     :loading="loading"
                     :disabled="!isValid">
                Login
              </v-btn>
            </v-card-actions>
            <v-card-actions class="tw-w-full tw-flex justify-center tw-mb-2">
              <span class="c-gray-text body-2" >Don't have an account? <router-link class="tw-font-bold" :to="{ name: 'SignUp', query: query }">REGISTER</router-link> </span>
            </v-card-actions>
          </v-card>

          <div class="tw-w-full">
            <div class="tw-w-full tw-flex tw-my-4 lg:tw-my-6 tw-items-center c-gray-text tw-text-center">
              <div class="tw-w-5/12">
                <hr>
              </div>
              <div class="tw-w-2/12">
                OR
              </div>
              <div class="tw-w-5/12">
                <hr>
              </div>
            </div>
            <get-quote :query="query" />
          </div>
          <div class="tw-w-full tw-flex tw-absolute tw-right-auto lg:tw-right-0 tw-bottom-0">
            <div class="tw-hidden lg:tw-block tw-w-full lg:tw-w-7/12">
            </div>
            <div class="tw-w-full lg:tw-w-5/12 tw-grid tw-grid-cols-2">
              <div class="c-bg-blue tw-py-1"></div>
              <div class="c-bg-red tw-py-1"></div>
            </div>
          </div>
        </v-col>

      </div>
    </v-main>
  </v-app>
</template>

<script>
import GetQuote from '@/components/auth/GetQuote';
import validations from '@/utils/validations';
import helpers from '@/utils/helpers';
import { mapGetters } from 'vuex';
import { FB_SIGNIN } from '@/utils/const';

export default {
  metaInfo: {
    title: 'Sign In',
  },
  components: { GetQuote },
  props: {
    source: String,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      ...validations,
      loading: false,
      isValid: false,
      passwordField: '',
      query: '',
      show: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['hasAuthenticationStatus', 'authenticationStatus', 'isConfirmed', 'authenticatedUser']),
  },
  mounted() {
    this.$store.dispatch('auth/clearAuthenticationStatus');
    const quote = this.$route.query.q;
    const benefit = this.$route.query.b;
    if (!!quote && !!benefit) {
      this.query = this.$route.query;
    }
  },
  methods: {
    async onSignIn() {
      this.loading = true;
      this.$store.dispatch('auth/signIn', {
        username: this.form.email,
        password: this.form.password,
      }).then(() => {
        if (this.hasAuthenticationStatus) {
          if (this.authenticationStatus.variant === 'error') {
            this.$toast.error(this.authenticationStatus.message, 'Error');
            this.loading = false;
          } else {
            this.$store.dispatch('auth/generateLoginOtp', { email: this.form.email, mobile: null }).then(() => {
              if (this.hasAuthenticationStatus) {
                if (this.authenticationStatus.variant === 'error') {
                  this.$toast.error(this.authenticationStatus.message, 'Error');
                  this.loading = false;
                } else {
                  this.$toast.success(this.authenticationStatus.message, 'Success');
                  this.$router.push({ name: 'ConfirmLoginOtp', query: this.query });
                  this.loading = false;
                }
              }
            });
          }
        }
      });
    },
    onNotConfirmed() {
      this.$store.dispatch('auth/generateOtp', { email: this.form.email, mobile: null }).then(() => {
        if (this.hasAuthenticationStatus) {
          if (this.authenticationStatus.variant === 'error') {
            this.$toast.error(this.authenticationStatus.message, 'Error');
          } else {
            this.$toast.success(this.authenticationStatus.message, 'Success');
          }
        }
        this.loading = false;
        this.$router.push({ name: 'ConfirmOtp', query: this.query });
      });
    },
    onConfirmed() {
      this.$analytics.setUserId(this.authenticatedUser.email);
      this.$analytics.setUserProperties({
        account_type: 'Customer-Portal',
      });
      this.$analytics.logEvent(FB_SIGNIN, { email: this.authenticatedUser.email });
      helpers.clearForm(this.form);
      if (this.$route.query.r) {
        window.location.href = atob(this.$route.query.r);
      } else if (this.query !== '') {
        this.$router.push({ name: 'BuyCover', query: this.query });
      } else this.$router.push({ name: 'Dashboard' });
    },
  },
};
</script>

<style lang="scss" scoped>
  .image {
    background-image: url('/images/bima.jpg');
    background-repeat: no-repeat;
    background-position: left;
    background-size: contain;
    background-attachment: cover;
    background-color: #D8EBFA;

  }
</style>
